import './main.farligaamnen.scss'

import $ from 'jquery'
window.$ = $
window.jQuery = $

import 'foundation-sites'
import '@mcfse/design-system'
import '@js/index.umd.js'

import { initFa } from '@js/fa.js'
import { initSite } from '@js/site.js'

// 👇 Vänta på att Klaro (från layout) laddas
function waitForKlaro(cb) {
    if (window.klaro && window.klaroConfig) {
        cb()
        return
    }

    const interval = setInterval(() => {
        if (window.klaro && window.klaroConfig) {
            clearInterval(interval)
            cb()
        }
    }, 50)
}

document.addEventListener('DOMContentLoaded', () => {

    waitForKlaro(() => {
        window.klaro.setup(window.klaroConfig)
    })

    initFa()
    initSite()
})